import {createRouter, createWebHistory} from 'vue-router'
const Layout = () => import('../views/layout.vue')
const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path:'',
                meta: {
                    title: '潍昌'
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/index')
            },{
                path: 'main',
                meta: {
                    title: '信息填写',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/main')
            }
        ]
    },
    /* 本段代码放在最后，未设置路由的地址跳转404 */
    {
        path: '/:catchAll(.*)',
        redirect: '/404'
    },
    {
        path: '/404',
        meta:{
            title:'页面不存在'
        },
        component: () => import(/* webpackChunkName:'second' */ '../views/404')
    },
    /** 本段代码放在最后，未设置路由的地址跳转404 */
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
